module.exports = __webpack_public_path__ + "static/media/auction.8c81b9e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/auction.png
// module id = 121
// module chunks = 0